<!--WpsEdit:WPS编辑 2021/08/13 14:02:12 Sunanguang-->

<template>
  <div class="bk-wps-edit">
    <div class="bk-wps-banner">
      <div class="banner-part aside">
        <a class="bk-logo" @click="exitAction" title="e课堂">
          <img src="images/logo_color.png" />
        </a>
      </div>
      <div class="banner-part middle">
        <el-input class="bk-edit-input" v-show="editName" v-model="updateName" placeholder="请输入内容"
                @blur="updateName = changeValue($event)" @keyup.enter.native="editTitle" autofocus maxlength="150">
        <a slot="append" class="svg-icon bk-item-ok its-icon its-icon-quedingi" href='javascript:;' @click="editTitle"></a>
        <a slot="append" class="svg-icon bk-item-close its-icon its-icon-quxiaoi" href='javascript:;' @click="editName=false"></a>
      </el-input>
      <p v-if="name.length > 0" v-show="!editName" class="title">
        <span :title="name">{{name}}</span>
        <span class="its-icon icon-edit its-icon-bianji1" data-io-click="tracker" @click="startEditTitle"></span>
      </p>
      </div>
      <div class="banner-part aside right">
        <button class="ts-base-btn ts-primary-btn plain"  style="margin: 0 40px 0 33px"
                @click="saveAction" :disabled="errorCode !== 1 || !editable" title="编辑模式也支持 Ctrl + S 进行保存哦 ~">
            <i class="its-icon its-icon-baocun"></i>保存
        </button>
      </div>
    </div>
    <div-no-data v-if="errorCode === -1" style="padding: 110px 20px;backgound: white">
      <p class="empty">
        {{errorMessage}}
        <span @click="getEidtInfo" style="color: #2695FF;cursor: pointer;">请稍后重试</span>
      </p>
    </div-no-data>
    <div v-else v-loading="loading" :id="'bk-wps-' + id" class="bk-wps"></div>
  </div>
</template>
<script>
import DivNoData from '@/views/components/DivNoData'
import { classSpaceApi } from '@/utils/api'
export default {
  name: 'ResourceEdit',
  components: {
    DivNoData
  },
  data () {
    return {
      updateName: '',
      editName: false,
      loading: false,
      errorCode: 0,
      errorMessage: '抱歉，文档获取失败，',
      name: '',
      id: 0,
      permission: 'edit',
      wps: null
    }
  },
  computed: {
    hiddenTags: function () {
      return this.$store.state.hiddenTags
    }
  },
  created () {
    try {
      localStorage.setItem('privacy', 'privacy')
      this.getEidtInfo()
    } catch (e) {
      this.setWpsError('localStorage')
    }
    this.name = this.$route.query.name
    this.setName()
  },
  methods: {
    setName: function () {
        classSpaceApi.getClassSpaceFileById(this.$route.query.bizId).then(resp=>{
            if (resp.success) {
                this.name = resp.body.fileName
            }
        })
    },
    exitAction: function () {
      window.close()
    },
    startEditTitle: function () {
      this.updateName = this.name
      this.editName = true
    },
    editTitle: function () {
      const vm = this
      if (this.updateName === '' || new RegExp('^[ ]+$').test(this.updateName)) {
        this.$message.error('名称不能为空！')
        return
      }
      // 校验特殊字符
      const reg = /["*<>?:|/'\\]/im
      if (reg.test(this.updateName)) {
        this.$message.error('名称中含有非法字符')
        return
      }
      let params = {
        id: this.$route.query.bizId,
        fileName: this.updateName
      }
      classSpaceApi.changeFileName(params).then(resp => {
        if (resp.success) {
          vm.name = vm.updateName
          vm.$message.success('修改名称成功！')
          vm.editName = false
        } else {
          this.$message.error(resp.message)
        }
      })
    },
    saveAction: async function () {
      const result = await this.wps.save()
      let msg = '保存成功'
      const state = result.result
      const states = {
        'ok': '文件修改保存成功,稍后即可生成最新文件的预览哦~',
        'nochange': '文档无更新，无需保存版本',
        'SavedEmptyFile': '暂不支持保存空文件',
        'SpaceFull': '空间已满',
        'QueneFull': '保存中请勿频繁操作',
        'fail': '保存失败'
      }
      msg = states[state]
      this.$message.success(msg)
    },
    getEidtInfo: function () {
      this.loading = true
      this.documentId = this.$route.params.id
      this.classSpaceId = this.$route.query.bizId
      this.editable = this.$route.params.permission === 'edit'
      if (this.editable === false) {
        document.title = document.title.replace('编辑', '查看')
      }
      const vm = this
      vm.errorCode = 0
      classSpaceApi.getDocumentCloudServiceUrl(this.documentId, 'WPS_CLOUD', this.editable,this.classSpaceId).then(function (resp) {
        if (resp.body) {
          vm.createWPS(resp.body.url)
          vm.loading = false
        }
      }).catch(function () {
        vm.loading = false
        vm.setWpsError()
      })
    },
    createWPS: function (url) {
      const bars = [
        'HeaderMiddle', // PC头部左侧
        'FloatQuickHelp' // 右下角帮助(金小豹)
      ]
      const hideBars = []
      bars.forEach((element) => {
        const option = { cmbId: element, attributes: { visible: false } }
        hideBars.push(option)
      })
      /* eslint-disable-next-line */
      this.wps = WebOfficeSDK.config({
        mount: document.getElementById('bk-wps-' + this.id),
        url: url,
        commandBars: hideBars
      })
      const vm = this
      // 打开文档结果
      this.wps.on('fileOpen', function (data) {
        if (data.success) {
          vm.errorCode = 1
        } else {
          vm.setWpsError(data.reason)
        }
      })
      this.wps.on('error', function (data) {
        vm.setWpsError(data.reason)
      })
    },
    setWpsError: function (key) {
      key = key || 'custom'
      const errors = {
        Unknown: '抱歉，未知错误，',
        userNotLogin: '抱歉，未登录，',
        InvalidLink: '抱歉，无效链接，',
        SessionFull: '抱歉，协作成员已满，',
        Fail: '抱歉，打开失败，',
        PermissionDenied: '抱歉，您的操作权限不足，',
        GetTokenFailed: '抱歉，获取token失败，',
        SessionExpired: '抱歉，会话过期，',
        fileTooLarge: '抱歉，文件过大，不支持预览服务，',
        custom: '抱歉，文档获取失败，',
        localStorage: '您当前可能处于无痕模式，要想正常访问本页面，需要在该浏览器的设置中取消`阻止第三方Cookie`的勾选或者切回正常模式使用，'
      }
      const msg = errors[key]
      this.errorMessage = msg || errors.custom
      this.errorCode = -1
    }
  }
}
</script>
<style scoped>
.bk-wps-edit {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #eaeef1;
  z-index: 2000;
}

.bk-logo {
  float: left;
}

.bk-wps-banner {
  width: 100%;
  height: 62px;
  background: white;
  box-shadow: 0px 4px 5px 0px rgba(0,0,0,0.03);
}

.bk-wps-banner .banner-part {
  float: left;
  height: 100%;
}

.banner-part.aside {
  width: 300px;
}

.banner-part.middle {
  width: calc(100% - 600px);
  text-align: center;
}

.aside.right {
  text-align: right;
  padding: 15px 0;
}

.middle .title {
  width: 100%;
  margin-top: 19px;
}

.middle .title > span {
  max-width: 65%;
  display: inline-block;
  font-size: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.middle .title .its-icon-bianji1 {
  color: #BEBEBE;
  font-size: 13px;
  margin-left: 10px;
  cursor: pointer;
  margin: 4px;
}

.middle .bk-item-ok {
    width: 18px !important;
    height: 18px !important;
    margin-top: 16px !important;
    float: left;
}

.svg-icon {
  color: #2695ff;
  font-size: 14px;
  margin-right: 1px;
}

.middle .bk-item-close {
    width: 14px !important;
    height: 14px !important;
    margin-top: 16px !important;
    float: left;
    margin-left: 8px;
}

.bk-edit-input {
  margin-top: 8px;
  width: 65%;
}

.bk-edit-input >>> .el-input__inner{
  background: transparent;
  border-radius: 0;
  border:none;
  border-bottom: 1px solid #BEBEBE;
  font-size: 18px;
  float: left;
  text-align: center;
  max-width: calc(100% - 58px)
}
.bk-edit-input >>> .el-input-group__append {
  background: transparent;
  border: none;
  width: 58px;
  display: inline-block;
  padding: 0 8px;
}

.bk-wps {
  width: 100%;
  height: calc(100vh - 66px);
}

.bk-wps iframe {
  height: 100% !important;
}

.bk-wps >>> .el-loading-mask {
  background: #f2f4f7;
}

.bk-close {
  position: absolute;
  right: 28px;
  font-size: 18px;
  top: 18px;
  color: #bebebe;
  cursor: pointer;
}

.bk-close:hover {
  color: #2695ff;
}

.bk-logo img {
  height: 42px;
  margin-top: 10px;
  margin-left: 20px;
  cursor: pointer;
}
</style>
